module.exports = __webpack_public_path__ + "img/logo-canelos.a2382ecf.png";